import { PublicKey } from "@solana/web3.js";

import * as anchor from "@project-serum/anchor";



/* async function getAccountInfo(address, rpcAddress) {
  let data = {
    jsonrpc: "2.0",
    id: 1,
    method: "getAccountInfo",
    params: [
      address,
      {
        encoding: "base64",
      },
    ],
  };

  let response = await fetch(rpcAddress, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  let resData = await response.json();
  console.log(resData);
  return resData;
} */

function parseConfigData(dataRaw, offset) {
  const ARRAY_START = 717;

  const LINE_SIZE =
    4 +
    32 + // max name length
    4 +
    200; // max uri length

  offset = Buffer.from(dataRaw, "base64");

  let arrayLength = offset.readInt32LE(ARRAY_START - 4);
  console.log(arrayLength);
  let items = new Array(arrayLength);
  for (let i = 0; i < arrayLength; i++)
    items[i] = parseConfigLine(offset, ARRAY_START + i * LINE_SIZE);

  return items;
}

function parseConfigLine(data, offset) {
  offset += 4;
  let name = data.toString("utf8", offset, offset + 32).replace(/\0/g, "");
  offset += 32;

  offset += 4;
  let link = data.toString("utf8", offset, offset + 200).replace(/\0/g, "");
  offset += 200;

  return { name, link };
}

export default async function main(configAddress, rpcAddress) {
  let newAddress = new PublicKey(configAddress)
  let candyMachineConfig
  try {
   // console.log(configAddress)
   // console.log(newAddress)
    let connection = new anchor.web3.Connection("https://ssc-dao.genesysgo.net/");
     candyMachineConfig = await connection.getAccountInfo(newAddress);
  //   console.log(candyMachineConfig)
  } catch (error) {
    console.log(error)
  }
  
  let candyMachineConfigData = candyMachineConfig.data;
  let items = parseConfigData(candyMachineConfigData);

  console.log(`Found ${items.length} NFTs`);
  console.log(items.filter((e) => e.name !== "").length);

  /* let cacheItems = Object.fromEntries(items.map((e, i) => [i.toString(), e])); */

/*   let cache = {
    program: {
      uuid: configAddress.substring(0, 6),
      config: configAddress,
    },
    items: cacheItems,
  }; */
  //await fs.writeFile(outputPath, JSON.stringify(cache, null, 2));

 // for (let item of items) console.log(item);
  return items
}

if (require.main) main(process.argv.slice(2)).catch(console.error);
